import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SedePuntoAtencion, CitaLaboratorioEntity, ServicioLaboratorioService,
  CitaLaboratorioExcelEntity, CitaLaboratorioBodyEntity } from 'src/app/services/servicio-laboratorio.service';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FileService } from 'src/app/services/utils/file.service';
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/utils/excel.service';

@Component({
  selector: 'app-header-citas-laboratorio',
  templateUrl: './header-citas-laboratorio.component.html',
  styleUrls: ['./header-citas-laboratorio.component.css']
})
export class HeaderCitasLaboratorioComponent implements OnInit {

  canDownload: boolean; // Indicador que existe data
  loading: boolean; // Indicador de carga en header
  downloading: boolean; // Indicado de descarga en header
  sedePuntoAtencion: number;
  fechaInicial: string; // Valor fecha inicial del formulario
  fechaFinal: string; // Valor fecha final del formulario
  mensajeError: string; // Mensaje de error

  sedesPuntosAtencion: SedePuntoAtencion[]; // Lista sedes puntos atencion

  @Input() public objetoCitaEntity: CitaLaboratorioEntity;
  @Input() public objectoCitaBodyEntity: CitaLaboratorioBodyEntity[];
  @Output() filtroSeleccionados: EventEmitter<CitaLaboratorioEntity>;

  constructor( private servicioLaboratorio: ServicioLaboratorioService,
               private servicioArchivo: FileService,
               private servicioFecha: FechaService,
               private servicioExcel: ExcelService) {
    this.loading = true;
    this.filtroSeleccionados = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }

  async init() {
    if (!this.sedesPuntosAtencion || this.sedesPuntosAtencion.length === 0) {
      if (this.objetoCitaEntity && this.objetoCitaEntity.sedePuntoAtencion !== 0) {
        this.sedePuntoAtencion = Number(this.objetoCitaEntity.sedePuntoAtencion);
      } else {
        this.sedePuntoAtencion = 0;
      }
      this.fechaInicial = this.servicioFecha.getInputValue(new Date().getTime());
      this.fechaFinal = this.servicioFecha.getInputValue(new Date().getTime());
      this.getSedesPuntosAtencion();
    }
  }

  async getSedesPuntosAtencion() {
    try {
      const response = await this.servicioLaboratorio.getSedesPuntosAtencion(this.objetoCitaEntity);
      if (response != null) {
        response.subscribe((data: SedePuntoAtencion[]) => {
          this.sedesPuntosAtencion = data;
          this.onGenerar();
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.sedesPuntosAtencion = [];
          this.loading = false;
        });
      }
    } catch (e) {
      console.error(`header-citas-laboratorio.getSedesPuntosAtencion() ${e}`);
    }
  }

  onGenerar() {
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    const obj: CitaLaboratorioEntity = {
      codigo : this.objetoCitaEntity.codigo,
      fechaInicial : 0,
      fechaFinal : 0,
      sedePuntoAtencion : -1,
      descripcionSedePuntoAtencion : ''
    };

    if (inicio === null || inicio.getTime() === 0) {
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Inicial</strong>.');
    } else if (fin === null || fin.getTime() === 0) {
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Final</strong>.');
    } else if (Number(this.sedePuntoAtencion) === 0) {
      this.mostrarMensaje('Debe seleccionar el campo <strong>Punto Atención</strong>.');
    } else if (this.servicioFecha.compare(inicio, fin) === 1) {
      this.mostrarMensaje('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
    } else {
      obj.fechaInicial = inicio.getTime();
      obj.fechaFinal = fin.getTime();
      obj.sedePuntoAtencion = Number(this.sedePuntoAtencion);
      obj.descripcionSedePuntoAtencion = this.getSedePuntoAtencion(Number(this.sedePuntoAtencion));

      this.objetoCitaEntity = obj;
      this.canDownload = obj.fechaInicial > 0;
    }
    this.filtroSeleccionados.emit(obj);
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('citas-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

  onDescargarPDF() {
    try {
      if (this.validatePDF()) {
        this.downloading = true;
        const data =  xepOnline.Formatter.Html('citas-print', { resolution : '200'});
        const html = `<!DOCTYPE html><head><meta charset="UTF-8"/><title>Citas Laboratorio</title></head><body>${data}</body></html>`;
        const response = this.servicioArchivo.generatePDF(html, 'Citas Laboratorio', 'citasLaboratorio');

        response.subscribe((datas: any) => {
          const filename = datas.filename;
          this.servicioArchivo.downloadFile(filename)
          .subscribe((dato) => {
            saveAs(dato, filename);
            this.downloading = false;
          }, err => {
            this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
            console.error('Error download', err);
            this.downloading = false;
          });
        }, (err: HttpErrorResponse) => {
          console.error('Error', err);
          this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
          this.downloading = false;
        });
      }
    } catch (e) {
      console.error(e);
      this.downloading = false;
      this.mostrarMensaje('Error al intentar generar pdf, reporte caso al administrador');
    }
  }

  onDescargarExcel() {
    this.downloading = true;
    const initialData: CitaLaboratorioBodyEntity[] = this.objectoCitaBodyEntity;
    const finalData: CitaLaboratorioExcelEntity[] = [];

    if (initialData && initialData.length > 0) {
      initialData.forEach((d: CitaLaboratorioBodyEntity) => {
        const f: CitaLaboratorioExcelEntity = {
          puntoAtencion : d.sedePuntoAtencion,
          periodoInicial : this.servicioFecha.getDateTimeValue(new Date(d.periodoInicial)),
          identificacion : d.identificacion,
          primerNombre : d.primerNombre,
          segundoNombre : d.segundoNombre,
          primerApellido : d.primerApellido,
          segundoApellido : d.segundoApellido,
          telefono : d.telefono,
          correo : d.correo,
          empresa : d.empresa,
          servicio : d.servicio
        };
        finalData.push(f);
      });
      this.servicioExcel.exportAsExcelFile(finalData, 'citasLaboratorio', 'Citas Laboratorio');
      this.downloading = false;
    } else {
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }
  }

  // Auxiliares

  getSedePuntoAtencion(unco: number): string {
    if (unco === -1) {
      return 'Todos los puntos atencion';
    } else {
      const spa = this.sedesPuntosAtencion.find((s: SedePuntoAtencion) => s.unco === unco);
      if (spa) {
        return spa.sede.descripcionCorta + '-' + spa.puntoAtencion.descripcion;
      } else {
        return '--';
      }
    }
  }

  validatePDF(): boolean {
    if (!this.objectoCitaBodyEntity || this.objectoCitaBodyEntity.length < 500) {
      return true;
    } else {
      this.mostrarMensaje('El reporte supera los 500 registros, por favor genere un archivo excel.');
      return false;
    }
  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 3500);
  }

}
